import { memo } from "react";
import { Modal } from "rsuite";
import { EmptyState, Loader } from "../../../components";
import BestStartButton from "../../../components/button";
import { IoSaveOutline } from "react-icons/io5";

function PreviousMonthDialog({
  previousMonthDialog,
  isReflectionSaving,
  onClose,
  onUpdateReflectionNotes,
  onSaveReflection,
}) {
  return (
    <Modal
      backdrop="static"
      keyboard={!previousMonthDialog.loading && !isReflectionSaving}
      open={previousMonthDialog.open}
      onClose={onClose}
      size="sm"
      className="scorecard-previous-month-modal"
    >
      <Modal.Header>
        <Modal.Title>Previous Month Entry</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="scorecard-previous-month-body">
          <section className="scorecard-previous-month-hero">
            <span className="home-operations-label">KPI</span>
            <h4>{previousMonthDialog.itemLabel}</h4>
            <p>
              {previousMonthDialog.groupLabel}
              {previousMonthDialog.month && previousMonthDialog.year
                ? ` • ${previousMonthDialog.month}/${previousMonthDialog.year}`
                : ""}
            </p>
          </section>

          {previousMonthDialog.loading && <Loader content="Loading previous month entry" />}

          {!previousMonthDialog.loading && previousMonthDialog.error && (
            <EmptyState
              title="Previous month entry unavailable"
              message={previousMonthDialog.error}
              className="home-empty-state"
            />
          )}

          {!previousMonthDialog.loading && !previousMonthDialog.error && (
            <div className="scorecard-previous-month-grid">
              <div className="scorecard-previous-month-panel">
                <span className="home-operations-label">Recorded KPI value</span>
                <strong>{previousMonthDialog.valueLabel}</strong>
              </div>

              <div className="scorecard-previous-month-panel">
                <span className="home-operations-label">Focus commentary</span>
                <p>{previousMonthDialog.focus?.kpiFocusCommentary || "No prior focus commentary saved."}</p>
              </div>

              <div className="scorecard-previous-month-panel">
                <span className="home-operations-label">Previous month success</span>
                <p>{previousMonthDialog.focus?.previousMonthSuccess || "No previous success note saved."}</p>
              </div>

              <div className="scorecard-previous-month-panel">
                <span className="home-operations-label">Specific action</span>
                <p>{previousMonthDialog.focus?.specificAction || "No specific action saved."}</p>
              </div>

              <label className="scorecard-goal-field scorecard-previous-month-reflection-field">
                <span>Reflection</span>
                <textarea
                  rows={4}
                  value={previousMonthDialog.reflectionNotes}
                  onChange={(event) => onUpdateReflectionNotes(event.target.value)}
                  placeholder="Add a reflection against this previous month entry."
                  disabled={isReflectionSaving || previousMonthDialog.readOnly}
                  readOnly={previousMonthDialog.readOnly}
                />
              </label>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer className="scorecard-goal-modal-footer">
        {!previousMonthDialog.readOnly && (
          <BestStartButton
            aria-label={isReflectionSaving ? "Saving reflection" : "Save reflection"}
            className="scorecard-goal-action"
            color="green"
            content={<><IoSaveOutline aria-hidden="true" size={16} /><span>{isReflectionSaving ? "Saving..." : "Save reflection"}</span></>}
            height={38}
            onClick={onSaveReflection}
            disabled={previousMonthDialog.loading || isReflectionSaving || !previousMonthDialog.focus?.id}
            width="100%"
          />
        )}
        <BestStartButton
          text="Close"
          aria-label="Close previous month entry"
          className="scorecard-goal-action"
          color="blue"
          height={38}
          onClick={onClose}
          disabled={previousMonthDialog.loading || isReflectionSaving}
          width="100%"
        />
      </Modal.Footer>
    </Modal>
  );
}

export default memo(PreviousMonthDialog);
